import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "notfound" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "notfound__inner" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "404"),
    /*#__PURE__*/_createElementVNode("p", null, "PAGE NOT FOUND")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_BackBtn = _resolveComponent("BackBtn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageHeader, { title: "NOT FOUND" }),
    _hoisted_1,
    _createVNode(_component_BackBtn, {
      url: "/",
      text: "HOME"
    })
  ], 64))
}